import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ScoreText } from "../components/ScoreText";
import { Grid, Paper } from "@mui/material";

interface ScorebugProps {
  homeScore: string;
  awayScore: string;
  scale: number;
}

const ScorebugSolves: React.FC<ScorebugProps> = ({ homeScore, awayScore, scale }) => {
  const fullWidth = scale + "vw";
  const halfWidth = (scale / 2) + "vw";
  const titleHeight = (scale / 8) + "vh";
  const titleFontSize = ((scale / 8) * .8) + "vh";
  const subtitleFontSize = ((scale / 8) * .6) + "vh";
  const scoreHeight = (scale / 2.5) + "vh";
  const scoreFontSize = ((scale / 3)) + "vh";

  return (
    
      <Grid container spacing={0}>
        <Grid item xs={12} display="flex" justifyContent="center">

          <Box
            bottom={0}
            left={0}
            width={fullWidth}
            px={"1px"}
            py={"1px"}
            bgcolor="black"
          >
            <Grid container spacing={0}>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <Box
                  sx={{
                    height: scoreHeight,
                    width: halfWidth,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 800,
                    color: 'white',
                    bgcolor: "var(--bg-color)",
                    paddingRight: "1px",
                    marginLeft: "2px"
                  }}
                >
                  <Box
                    sx={{
                      height: scoreHeight,
                      width: halfWidth,
                      borderTop: '2px solid #f7941e', // thick blue border
                      borderBottom: '2px solid #f7941e', // thick blue border
                      borderLeft: '2px solid #f7941e', // thick blue border
                      borderRight: '2px solid #f7941e', // thick blue border
                      borderRadius: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: 800,
                      color: 'white',
                      bgcolor: "var(--bg-color)"
                    }}
                  >
                    <ScoreText size={scoreFontSize} value={awayScore} weight={900} spacing="3px" />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-start">
                <Box
                  sx={{
                    height: scoreHeight,
                    width: halfWidth,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 800,
                    color: 'white',
                    bgcolor: "var(--bg-color)",
                    paddingLeft: "1px",
                    marginRight: "2px"
                  }}
                >
                  <Box
                    sx={{
                      height: scoreHeight,
                      width: halfWidth,
                      borderTop: '2px solid #f7941e', // thick blue border
                      borderBottom: '2px solid #f7941e', // thick blue border
                      borderLeft: '2px solid #f7941e', // thick blue border
                      borderRight: '2px solid #f7941e', // thick blue border
                      borderRadius: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: 800,
                      color: 'white',
                      bgcolor: "var(--bg-color)"
                    }}
                  >
                    <ScoreText size={scoreFontSize} value={homeScore} weight={900} spacing="3px" />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
  );
}
export default ScorebugSolves;